import React, { createContext, useContext, useState } from 'react';
import { ThemeProvider } from '@mui/material/styles';
import { Outlet, useLocation } from 'react-router-dom';
import { BsBoxArrowLeft } from "react-icons/bs";
import DropdownMenu from '../../Layout/Admin/Menu';
import { ContextNotification, severitys } from '../../App';
import PrivateRoutList from '../../Router/PrivateRoutList';
import logo from "../../assets/logo-header.png"
import UserApi from '../../api/UserApi';
import themes from '../../themes';
import Box from '@mui/material/Box';
import Drawer from '@mui/material/Drawer';
import CssBaseline from '@mui/material/CssBaseline';
import AppBar from '@mui/material/AppBar';
import Toolbar from '@mui/material/Toolbar';
import List from '@mui/material/List';
import Typography from '@mui/material/Typography';
import Divider from '@mui/material/Divider';
import { MdClose, MdMenu } from 'react-icons/md';
import { Grid2, IconButton, Paper, Tooltip } from '@mui/material';

import styled from 'styled-components';
import RtlProvider from '../../Components/RtlProvider';
import MobileMenu from '../../Layout/Admin/MobileMenu';
import enumMapper from '../../enumMapper';

export const ContextMenues = createContext();
export const ContextUserInfo = createContext();

const exitToApp = () => {
  localStorage.clear();
  window.location.pathname = "/login";
}
const drawerWidth = 240;
export default function MainPanel() {
  const appid = enumMapper.AppId.Plan;
  const [hasAccess, setHasAccess] = React.useState(false)
  const [menues, setMenues] = React.useState([]);
  const [refresh, setRefresh] = useState(false);
  const location = useLocation();
  const [userInfo, setUserInfo] = React.useState(null);
  const [userRoles, setUserRoles] = React.useState([]);
  const [userPermissions, setUserPermissions] = React.useState(null);
  const { setOpen } = useContext(ContextNotification);

  React.useEffect(() => {
    GetMenues();
    GetPermissions();
    setHasAccess(CheckAccess());
  }, [location]);

  React.useEffect(() => {
    setHasAccess(CheckAccess());
  }, [refresh]);

  const GetMenues = () => {
    return UserApi.GetMenuItems(appid)
      .then((data) => {
        setMenues(data.data);
      })
      .catch(err => {
        if (err.response && err.response.data) {
          setOpen({ IsEnable: true, Message: JSON.stringify(err.response.data), severity: severitys.error });
        }
        else if (err.response && err.response.data && err.response.data.errors) {
          setOpen({ IsEnable: true, Message: JSON.stringify(err.response.data.errors), severity: severitys.error });
        }
        else if (err.message) {
          setOpen({ IsEnable: true, Message: JSON.stringify(err.message), severity: severitys.error });
        }
        exitToApp();
      }
      );
  };

  const GetPermissions = () => {
    return (
      UserApi.GetPermissions(appid)
        .then(async (data) => {
          setUserInfo(data.data.user)
          setUserPermissions(data.data.permisions);
          setUserRoles(data.data.roles)
          setRefresh(old => !old);
        })
        .catch(err => {
          if (err.response && err.response.data) {
            setOpen({ IsEnable: true, Message: JSON.stringify(err.response.data), severity: severitys.error });
          }
          else if (err.response && err.response.data && err.response.data.errors) {
            setOpen({ IsEnable: true, Message: JSON.stringify(err.response.data.errors), severity: severitys.error });
          }
          else if (err.message) {
            setOpen({ IsEnable: true, Message: JSON.stringify(err.message), severity: severitys.error });
          }
        }
        )
    );
  };
  function CheckAccess() {
    var res = false;
    var prout = null;
    var pathparts = location.pathname.trim().trimEnd('/').toLowerCase().split('/');
    if ((pathparts.length >= 2) && (pathparts[1] === 'dashboard')) {
      if (pathparts.length === 2)
        return true;
      else if ((pathparts.length === 3) && (pathparts[2].toLowerCase() === 'home'))
        res = (userPermissions ? true : false)
      else {
        prout = PrivateRoutList.find(e => (e.name.toLowerCase() === (pathparts[2] + ':' + pathparts[3])));
        if (prout)
          res = userPermissions?.some(p => (p.claimType.toLowerCase() === pathparts[2]) && (p.claimValue.toLowerCase() === pathparts[3]))
        else {
          prout = PrivateRoutList.find(e => (e.path.toLowerCase()) === (pathparts.length === 3 ? pathparts[2] : pathparts[2] + '/' + pathparts[3]))
          if (prout) {
            res = menues?.some(pmenu =>
              prout.name === pmenu.menuName)
            if (!res)
              res = menues?.map(mnu => mnu.children.some(pmenu =>
                prout.name === pmenu.menuName) ? 1 : 0).includes(1)
          }
        }
      }
    }
    return res
  };

  const getUserName = () => {
    var res = '';
    if (userInfo)
      res = userInfo.firstName + ' ' + userInfo.lastName;
    return res;
  }


  const [mobileOpen, setMobileOpen] = React.useState(false);
  const [isClosing, setIsClosing] = React.useState(false);

  const handleDrawerClose = () => {
    setIsClosing(true);
    setMobileOpen(false);
  };

  const handleDrawerTransitionEnd = () => {
    setIsClosing(false);
  };

  const handleDrawerToggle = () => {
    if (!isClosing) {
      setMobileOpen(!mobileOpen);
    }
  };

  const drawer = (
    <div>
      <Toolbar />
      <Divider />
      <List component="nav">
        <ContextMenues.Provider value={{ menues, setMenues }}>
          <DropdownMenu />
        </ContextMenues.Provider>
      </List>
    </div>
  );
  const mobileDrawer = (
    <div>
      <Toolbar>
        <IconButton onClick={handleDrawerToggle}
        >
          <MdClose />
        </IconButton>
      </Toolbar>
      <Divider />
      <List component="nav">
        <ContextMenues.Provider value={{ menues, setMenues }}>
          <MobileMenu drawerClose={handleDrawerClose} />
        </ContextMenues.Provider>
      </List>
    </div>
  );


  return (
    <RtlProvider>
      <ThemeProvider theme={themes.defaultTheme}>
        <Box sx={{ display: 'flex' }}>
          <CssBaseline />
          <AppBar color={'beige'} position="fixed" sx={{ bgcolor: 'beige.main', zIndex: (theme) => theme.zIndex.drawer + 1 }}>
            <Toolbar>
              <div style={{ width: '100%', paddingTop: '5px', paddingBottom: '5px' }}>
                <Box
                  sx={{ display: 'flex', alignItems: 'center' }}
                >
                  <Box sx={{ flexGrow: 1 }}>
                    <Typography variant="h6" component="h1" sx={{ display: { xs: 'block', sm: 'none' }, fontFamily: 'BFarnaz !important', fontSize: { xs: '1rem', sm: '1rem', md: '2rem' } }}>
                      سامانه پلان اقامتی عمره                    </Typography>
                  </Box>
                  <Box sx={{ display: 'flex', alignItems: 'center', textAlign: 'center' }}>
                    <IconButton
                      aria-label="open drawer"
                      onClick={handleDrawerToggle}
                      sx={{ display: { sm: 'none' }, color: '#86A7FC' }}
                    >
                      <MdMenu />
                    </IconButton>
                  </Box>
                </Box>

                <Box
                  sx={{ display: 'flex' }}
                >
                  <Box sx={{ flexGrow: 1 }}>
                    <Box sx={{ display: 'flex', alignItems: 'center', textAlign: 'center' }}>
                      <img id="headerlogoimage" src={logo} alt="موسسه عمره سعادت" />
                      <Typography variant="h6" component="h1" sx={{ display: { xs: 'none', sm: 'block' }, fontFamily: 'BFarnaz !important', fontSize: { xs: '1rem', sm: '1rem', md: '2rem' } }}>
                        سامانه پلان اقامتی عمره                      </Typography>
                    </Box>
                  </Box>

                  <Box sx={{ display: 'flex', alignItems: 'center', textAlign: 'center' }}>
                    <Typography>{getUserName()}</Typography>
                    <Tooltip title="خروج از سامانه" placement="right">
                      <IconButton onClick={() => exitToApp()} sx={{ color: '#86A7FC' }}
                      >
                        <BsBoxArrowLeft />
                      </IconButton>
                    </Tooltip>
                  </Box>
                </Box>
              </div>
            </Toolbar>
          </AppBar>
          <Box
            component="nav"
            sx={{ width: { sm: drawerWidth }, flexShrink: { sm: 0 } }}
            aria-label="mailbox folders"
          >
            {/* The implementation can be swapped with js to avoid SEO duplication of links. */}
            <Drawer
              variant="temporary"
              open={mobileOpen}
              onTransitionEnd={handleDrawerTransitionEnd}
              onClose={handleDrawerClose}
              ModalProps={{
                keepMounted: true, // Better open performance on mobile.
              }}

              sx={{
                zIndex: (theme) => theme.zIndex.drawer + 1,
                width: drawerWidth,
                flexShrink: 0,
                [`& .MuiDrawer-paper`]: { width: drawerWidth, boxSizing: 'border-box' },
              }}
              PaperProps={{
                sx: {
                  backgroundColor: '#FFFFEC',
                }
              }}
            >
              {mobileDrawer}
            </Drawer>
            <Drawer
              variant="permanent"
              sx={{
                display: { xs: 'none', sm: 'block' },
                '& .MuiDrawer-paper': { boxSizing: 'border-box', width: drawerWidth },
              }}
              PaperProps={{
                sx: {
                  backgroundColor: 'rgb(255, 255, 255)',
                }
              }}
              open
            >
              {drawer}
            </Drawer>
          </Box>
          {/* Main content */}
          <Box
            component="main"
            sx={(theme) => ({
              flexGrow: 1,

              overflow: 'auto',
              p: 3,
              pt: { xs: 10, sm: 3 }
            })}
          >
            <Toolbar />
            {hasAccess && <ContextUserInfo.Provider value={{ userInfo, userPermissions, userRoles }}><Outlet /></ContextUserInfo.Provider>}
          </Box>
        </Box>
      </ThemeProvider>
    </RtlProvider>
  );
}
